﻿// contact us form
export const $CONTACT_US_FORM = $('#contact-us-form');

// contact us submit button
export const $CONTACT_US_SUBMIT_BUTTON = $('[data-identity="contact-us-submit-button"]');

// success message
export const CONTACT_SUCCESS_MESSAGE = 'Thank you, we will get to you ASAP!';